import React from "react";
import { Button } from 'react-bootstrap';
import './StepThree.scss';
import ScrollAnimation from 'react-animate-on-scroll';
import loadable from '@loadable/component'
const StepThree = (props) => {
  
  const Valpal = loadable(() => import('../StepTwo/valpal-result'))

  return (
    <div className="stepthree">
      <div className="d-lg-block">
         {/* <ScrollAnimation animateIn='fadeIn' animateOnce={true}> */}
          <div onClick={props.step === 0 ? props.handleBack : props.previous} onKeyPress={props.step === 0 ? props.handleBack : props.previous} className="back_icon"><i className="icon-back"></i> Back</div>
        {/* </ScrollAnimation> */}
      </div>
      <ScrollAnimation animateIn='fadeIn' animateOnce={true}>
        <h2>All done {props.name}! Here are the approximate sale and rental values for your property</h2>
      </ScrollAnimation>
      <Valpal addressBuildingName={props.addressBuildingName}
       addressBuildingNumber={props.addressBuildingNumber}
        addressPostalCode={props.addressPostalCode}
         addressSubBuilding={props.addressSubBuilding} 
         addressStreet={props.addressStreet}
          valpalsell={props.valpalsell}
           valpallet={props.valpallet}/>
           <div className="box">
                <h4>Are you now ready for an in person valuation?</h4>
                <p>Book a face-to-face valuation with one of our experts on your preferred date and time.</p>
                <p class="b-para">What are you waiting for?</p>

                <Button className="btn" onClick={props.next}>I’m Ready!</Button>
            </div>

      </div>
  )
}



export default StepThree